import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '😰',
  title: 'Épuisement Créatif',
  description: "Vous passez des heures sur YouTube, des sites d'entraîneurs et les réseaux sociaux à chercher des exercices qui s'articulent entre eux."
}, {
  emoji: '🍃',
  title: 'Manque de Structure',
  description: "Vos séances perdent en fluidité. Vous passez d'un exercice à l'autre en vous demandant si vos joueurs progressent vraiment de façon logique."
}, {
  emoji: '📱',
  title: "Surcharge d'Informations",
  description: "Vous cherchez en ligne et trouvez des milliers d'idées contradictoires. Chacun enseigne quelque chose de différent, et vous ne savez pas quel système fonctionne vraiment."
}, {
  emoji: '😩',
  title: 'Charge Mentale Immense',
  description: "Gérer les joueurs, planifier les séances, organiser les entraînements et préparer les matchs vous épuise avant même que l'entraînement commence."
}];
export function PainPoints() {
  return <section className="py-20 bg-navy-950 relative border-t border-navy-800" data-id="element-137" data-mp="1yyu2myjyvb5c">
      <div className="container mx-auto px-4" data-id="element-138" data-mp="1u0skcfud7fux">
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-139" data-mp="27sz0w31fjouw">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-4xl md:text-5xl text-white uppercase tracking-wide mb-6" data-id="element-140" data-mp="27s778xre8179">
ÇA VOUS PARLE ?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-400 font-medium" data-id="element-141" data-mp="1p3si6g0myx93">
            Vous adorez entraîner au football, mais planifier vos séances vous
            prend tout votre temps libre.
            <br className="hidden md:block" data-id="element-142" data-mp="1y62tonhodvz1" />
            Si vous êtes entraîneur de football, vous avez probablement déjà
            vécu l'une de ces situations :
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-143" data-mp="272k41oi7tptq">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-900/50 border border-navy-800 rounded-2xl p-8 hover:border-navy-600 transition-colors" data-id="element-144" data-mp="1efqxgpi59wbt" data-mpi={index}>
              <div className="text-4xl mb-4" data-id="element-145" data-mp="o4xd185ju7x3">{point.emoji}</div>
              <h3 className="font-oswald text-2xl text-white uppercase tracking-wide mb-3" data-id="element-146" data-mp="j6nf4psfwt7s">
                {point.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-147" data-mp="e6hi0u3eieib">
                {point.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}